import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import ShareViaStepIndicator from '../ShareViaStepIndicator';
import ConfigurationStepContent from './ConfigurationStepContent';
import ConfigurationStepFooter from './ConfigurationStepFooter';
// @ts-expect-error: no types
import { useControlsContext } from '../../../shareAsset/context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ConfigurationStepContainer = () => {
  const {
    isEditingScheduledEmail
  } = useControlsContext();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(DialogBody, {
      children: [!isEditingScheduledEmail && /*#__PURE__*/_jsx(ShareViaStepIndicator, {}), /*#__PURE__*/_jsx(ConfigurationStepContent, {})]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(ConfigurationStepFooter, {})
    })]
  });
};
export default ConfigurationStepContainer;